import {TypeLocalNameEnum} from 'domain/usecases';

export enum NetworkTypesEnum {
	ACCREDITED = 'credenciada',
	SUPPORT = 'apoio',
	SELF = 'propria',
}

export type GetExamsProviderLocationParams = {
	stateCode?: string;
	typeLocalName: TypeLocalNameEnum;
	cityName: string;
	examType: string;
	distance?: string;
	districtNames?: string;
	citiesNames?: string;
	signal?: AbortSignal;
};

export type ExamProviderLocation = {
	codigo: number;
	nome: string;
	nomeMedico: string;
	nmPrestador: string;
	cep: string;
	numero: number;
	logradouro: string;
	complemento: string;
	bairro: string;
	nmCidade: string;
	cdUf: string;
	latitude: string;
	longitude: string;
	pontoReferencia: string;
	distancia: number;
	nmBairroOrigem: string;
};

export type GetExamsProviderLocationModel = {
	unidadesPorLocal: ExamProviderLocation[];
	unidadesPorRaio: ExamProviderLocation[];
	rede: NetworkTypesEnum;
};

export interface GetExamsProviderLocation {
	get: (params: GetExamsProviderLocationParams) => Promise<GetExamsProviderLocationModel>;
}
